// Shareable link to one collection of a store: https://bloomhq.in/store/<slug>?collection=<id>.
// The store page (default template and Design Studio alike) opens straight onto that collection.
export const SITE_ORIGIN = "https://bloomhq.in";

export function collectionLink(slug, id, origin = SITE_ORIGIN) {
  if (!slug || !id) return "";
  return `${origin}/store/${encodeURIComponent(slug)}?collection=${encodeURIComponent(id)}`;
}

// The collection a visitor's URL asks for, or null when it is absent / not one of the store's collections.
export function collectionFromSearch(search, validIds) {
  let v = null;
  try { v = new URLSearchParams(search || "").get("collection"); } catch { /* bad search string */ }
  return v && Array.isArray(validIds) && validIds.includes(v) ? v : null;
}

// The search string after a visitor picks a collection ("All" / null removes the param); other params (?pay=… etc.) are kept.
export function withCollectionParam(search, id) {
  const p = new URLSearchParams(search || "");
  if (!id || id === "All") p.delete("collection"); else p.set("collection", id);
  const s = p.toString();
  return s ? `?${s}` : "";
}
